import { useState, useEffect } from "react";
import { Modal, ModalBody, ModalHeader, Row, Col, Button } from "reactstrap";
import WaitExport from "../../../components/WaitExport";
//redux
import { connect } from "react-redux";
//service
import {
  getMatchNoRoom,
  getStockRooms,
  createRoom,
  getParticipants,
  getConfigMatch,
} from "../../../utils/services/match";

import { createXlsx } from "./createGeneratedRoomsXlsx";
import ButtonSpinner from "../../../components/Buttons/ButtonSpinner";

function ModalLinksEmbeded(props) {
  const { isOpen, toggle, jwt, eventId } = props;
  const [getByGroup, setGetByGroup] = useState(null);
  const [exportInProgress, setExportInProgress] = useState(false);
  const [finishExport, setFinishExport] = useState(false);
  const [position, setPosition] = useState("0%");
  const [errorAlert, setErrorAlert] = useState("");
  const [isLoading, setIsloading] = useState(false);

  async function getAllMatchNoRoom(type) {
    if (props.roomAmount == 0) {
      setErrorAlert("Não existe quartos disponíveis.");
      return;
    }

    setErrorAlert("");
    var rooms = [];
    setIsloading(true);
    var erro = false;
    const isGroupFilter = true;

    let isSegregatedByPosition = false;
    let disregardedGroups = [];
    let blockedGroups = [];

    const matchConfig = await getConfigMatch({
      token: jwt,
      eventId: eventId,
    });

    if (matchConfig.data.length > 0) {
      isSegregatedByPosition = matchConfig.data[0].isSegregatedByPosition;
      disregardedGroups = matchConfig.data[0].disregardedGroups || [];
      blockedGroups = matchConfig.data[0].noMatchGroups || [];
    }

    const getEffectiveGroups = (user) =>
      user.grupos
        ?.filter((g) => !disregardedGroups.includes(g.id))
        .map((g) => g.id)
        .sort()
        .join(",");

    const getGroupNames = (user) =>
      user.grupos?.map((g) => g.name.toUpperCase()) || [];

    await getMatchNoRoom({
      eventId: eventId,
      limit: 100000000,
      offset: 1,
      jwt: jwt,
    }).then(async (res) => {
      const { count, data } = res;
      if (count == 0) {
        setErrorAlert("Não existe participantes sem quarto!");
        return;
      }

      let users = data
        .map((e) => ({
          id: e.login_id,
          name: e.login_nome,
          email: e.login_email,
          cargo: e.cargo,
          grupos: e.grupos,
          status: "completed",
        }))
        .filter((u) => !u.grupos.some((g) => blockedGroups.includes(g.id)));

      const stock = await getStockRooms({
        eventId: eventId,
        jwt: jwt,
      });

      var erroAmount = await vacanciesAmount(users, stock);
      if (erroAmount) {
        setErrorAlert(
          "Não existe quartos disponíveis para todos os participantes"
        );
        setIsloading(false);
        erro = true;
        return;
      }

      setExportInProgress(true);

      for (let r = 0; r < stock.length; r++) {
        const roomType = stock[r].descricao;
        const roomSize =
          roomType === "Single"
            ? 1
            : roomType === "Duplo"
            ? 2
            : roomType === "Triplo"
            ? 3
            : 4;
        let availableRooms = stock[r].disponivel;

        // Alocar usuários com grupo igual ao nome do quarto
        while (availableRooms > 0) {
          const matchingGroup = users.filter((u) =>
            getGroupNames(u).includes(roomType.toUpperCase())
          );

          if (matchingGroup.length < roomSize) break;

          const selectedGroup = matchingGroup.slice(0, roomSize);

          const [u1, u2, u3, u4] = [...selectedGroup, {}, {}, {}];

          rooms.push({
            typeRoom: roomType,

            id1: u1?.id || "",
            name1: u1?.name || "",
            email1: u1?.email || "",
            cargo1: u1?.cargo || "",
            grupos1: u1?.grupos?.map((g) => g.name).join(", ") || "",

            id2: u2?.id || "",
            name2: u2?.name || "",
            email2: u2?.email || "",
            cargo2: u2?.cargo || "",
            grupos2: u2?.grupos?.map((g) => g.name).join(", ") || "",

            id3: u3?.id || "",
            name3: u3?.name || "",
            email3: u3?.email || "",
            cargo3: u3?.cargo || "",
            grupos3: u3?.grupos?.map((g) => g.name).join(", ") || "",

            id4: u4?.id || "",
            name4: u4?.name || "",
            email4: u4?.email || "",
            cargo4: u4?.cargo || "",
            grupos4: u4?.grupos?.map((g) => g.name).join(", ") || "",
          });

          const payload = {
            sendEmail: false,
            eventId: eventId,
            roommateId: u1.id,
            roomSize: selectedGroup.length,
            status: "pending_accept",
            enabled: true,
            choosens: [
              selectedGroup.map((u, i) => ({
                id: u.id,
                name: u.name,
                email: u.email,
                status: "completed",
                order: i + 1,
                type: "choosen",
              })),
            ],
            idiom: "ptBr",
          };

          if (type !== "download") {
            await createRoom(payload, props.state.global_user_data.data.token);
          }

          users = users.filter(
            (u) => !selectedGroup.find((g) => g.id === u.id)
          );
          availableRooms--;
        }

        //Alocar usuários com mesmo grupo independente do quarto
        while (availableRooms > 0) {
          let foundGroup = null;

          for (let i = 0; i < users.length; i++) {
            const baseUser = users[i];
            const baseGroups = getEffectiveGroups(baseUser);

            const sameGroup = users.filter((u) => {
              if (u.id === baseUser.id) return false;

              const userGroups = getEffectiveGroups(u);
              const sameGroupMatch = baseGroups === userGroups;
              const samePositionMatch = u.cargo === baseUser.cargo;

              return isSegregatedByPosition
                ? sameGroupMatch && samePositionMatch
                : sameGroupMatch;
            });

            if (sameGroup.length >= roomSize - 1) {
              const selectedGroup = [
                baseUser,
                ...sameGroup.slice(0, roomSize - 1),
              ];
              foundGroup = selectedGroup;
              break;
            }
          }

          if (!foundGroup && users.length > 0) {
            const baseUser = users[0];
            const hasBlocked = baseUser.grupos.some((g) =>
              blockedGroups.includes(g.id)
            );
            if (!hasBlocked) {
              foundGroup = [baseUser];
            }
          }

          if (!foundGroup) break;

          const hasBlockedGroup = foundGroup.some((u) =>
            u.grupos?.some((g) => blockedGroups.includes(g.id))
          );

          if (hasBlockedGroup) {
            users = users.filter((u) => !foundGroup.find((g) => g.id === u.id));
            continue;
          }

          const [u1, u2, u3, u4] = [...foundGroup, {}, {}, {}];

          rooms.push({
            typeRoom: roomType,

            id1: u1?.id || "",
            name1: u1?.name || "",
            email1: u1?.email || "",
            cargo1: u1?.cargo || "",
            grupos1: u1?.grupos?.map((g) => g.name).join(", ") || "",

            id2: u2?.id || "",
            name2: u2?.name || "",
            email2: u2?.email || "",
            cargo2: u2?.cargo || "",
            grupos2: u2?.grupos?.map((g) => g.name).join(", ") || "",

            id3: u3?.id || "",
            name3: u3?.name || "",
            email3: u3?.email || "",
            cargo3: u3?.cargo || "",
            grupos3: u3?.grupos?.map((g) => g.name).join(", ") || "",

            id4: u4?.id || "",
            name4: u4?.name || "",
            email4: u4?.email || "",
            cargo4: u4?.cargo || "",
            grupos4: u4?.grupos?.map((g) => g.name).join(", ") || "",
          });

          const payload = {
            sendEmail: false,
            eventId: eventId,
            roommateId: u1.id,
            roomSize: foundGroup.length,
            status: "pending_accept",
            enabled: true,
            choosens: [
              foundGroup.map((u, i) => ({
                id: u.id,
                name: u.name,
                email: u.email,
                status: "completed",
                order: i + 1,
                type: "choosen",
              })),
            ],
            idiom: "ptBr",
          };

          if (type !== "download") {
            await createRoom(payload, props.state.global_user_data.data.token);
          }

          users = users.filter((u) => !foundGroup.find((g) => g.id === u.id));
          availableRooms--;
        }

        setPosition(`${r * 10}%`);
      }
    });

    if (erro) return;

    if (type === "download") {
      createXlsx(rooms, setFinishExport, isGroupFilter);
    } else {
      setIsloading(false);
      setFinishExport(true);
      setPosition(`${100}%`);
    }
  }

  async function getAllMatchNoRoomNoGroup(type) {
    if (props.roomAmount == 0) {
      setErrorAlert("Não existe quartos disponiveis.");
      return;
    }
    const isGroupFilter = false;

    setErrorAlert("");

    var rooms = [];

    setIsloading(true);

    var erro = false;

    await getMatchNoRoom({
      eventId: eventId,
      limit: 100000000,
      offset: 1,
      jwt: jwt,
    }).then(async (res) => {
      const { count, data } = res;

      if (count == 0) {
        setErrorAlert("Não existe participantes sem quarto!");
        return;
      }
      let users = data.map((e) => {
        return {
          id: e.login_id,
          name: e.login_nome,
          email: e.login_email,
          status: "completed",
        };
      });
      const stock = await getStockRooms({
        eventId: eventId,
        jwt: jwt,
      });

      var erroAmount = await vacanciesAmount(users, stock);

      if (erroAmount) {
        setErrorAlert(
          "Não existe quartos disponiveis para todos os participantes"
        );
        setIsloading(false);
        erro = true;
        return;
      }

      let stockControl = 0;

      let indexRoom = 0;
      let indexRefer = 0;

      setExportInProgress(true);

      for (let r = 0; r < stock.length; r++) {
        if (stock[r].descricao == "Single") indexRefer = 1;
        else if (stock[r].descricao == "Duplo") indexRefer = 2;
        else if (stock[r].descricao == "Triplo") indexRefer = 3;
        else indexRefer = 4;

        for (let s = 0; s < stock[r].disponivel; s++) {
          if (users.slice(indexRoom, indexRefer + indexRoom).length == 0) break;

          stockControl++;
          if (stockControl >= users.length) break;

          const payload = {
            sendEmail: false,
            eventId: eventId,
            roommateId: users.slice(indexRoom, indexRefer + indexRoom)[0].id,
            roomSize:
              (stock[r].descricao == "Single" && 1) ||
              (stock[r].descricao == "Duplo" && 2) ||
              (stock[r].descricao == "Triplo" && 3) ||
              (stock[r].descricao == "Quadruplo" && 4),
            status: "pending_accept",
            enabled: true,
            choosens: [
              users.slice(indexRoom, indexRefer + indexRoom).map((e, i) => {
                return {
                  ...e,
                  order: i + 1,
                  type: "choosen",
                };
              }),
            ],
            idiom: "ptBr",
          };

          const usersRooms = payload.choosens[0];

          rooms.push({
            typeRoom: stock[r].descricao,
            id1: usersRooms[0].id,
            name1: usersRooms[0].name,
            email1: usersRooms[0].email,
            id2: usersRooms[1] ? usersRooms[1].id : "",
            name2: usersRooms[1] ? usersRooms[1].name : "",
            email2: usersRooms[1] ? usersRooms[1].email : "",
            id3: usersRooms[2] ? usersRooms[2].id : "",
            name3: usersRooms[2] ? usersRooms[2].name : "",
            email3: usersRooms[2] ? usersRooms[2].email : "",
            id4: usersRooms[3] ? usersRooms[3].id : "",
            name4: usersRooms[3] ? usersRooms[3].name : "",
            email4: usersRooms[3] ? usersRooms[3].email : "",
          });

          if (type != "download") {
            await createRoom(payload, props.state.global_user_data.data.token);
          }

          if (stock[r].descricao == "Single") indexRoom += 1;
          else if (stock[r].descricao == "Duplo") indexRoom += 2;
          else if (stock[r].descricao == "Triplo") indexRoom += 3;
          else indexRoom += 4;
        }

        setPosition(`${r * 10}%`);
      }
    });

    if (erro) return;

    if (type === "download") {
      createXlsx(rooms, setFinishExport, isGroupFilter);
    } else {
      setIsloading(false);
      setFinishExport(true);
      setPosition(`${100}%`);
    }
  }

  async function vacanciesAmount(users, stock) {
    var totalVacancies = 0;

    stock.forEach((room, index) => {
      if (room.descricao === "Single") {
        totalVacancies += room.disponivel * 1;
      } else if (room.descricao === "Duplo") {
        totalVacancies += room.disponivel * 2;
      } else if (room.descricao === "Triplo") {
        totalVacancies += room.disponivel * 3;
      } else {
        totalVacancies += room.disponivel * 4;
      }
    });

    if (totalVacancies < users.length) {
      return true;
    } else return false;
  }

  useEffect(() => {
    /* getMatchNoRoom({
      eventId: eventId,
      limit: 100000000,
      offset: 1,
      jwt: jwt,
    }).then(async (res) => {
      const { count, data } = res;
      console.log(data);
    }); */
    /* getParticipants({
      eventId: eventId,
      loginId: "5cd9e95a-865e-4228-9913-17341de51185",
      limit: 100000000,
      offset: 1,
      jwt: jwt,
    }).then(async (res) => {
      const { count, data } = res;
      console.log(data);
    }); */
  }, []);

  return (
    <Modal isOpen={isOpen} autoFocus={true} centered={true}>
      <WaitExport
        customFinishTitle={"Preenchimento concluído."}
        customHeaderText={"Preenchendo Quartos"}
        customBodyText={`Em breve o preenchimento dos quartos será concluído, aguarde alguns instantes.`}
        isOpen={exportInProgress}
        name="Participantes sem Quarto"
        preposicao="dos"
        finishExport={finishExport}
        setFinishExport={() => {
          toggle();
          props.updateTables();
        }}
        setExportInProgress={setExportInProgress}
        position={position}
      />
      <ModalHeader toggle={toggle}>Gerar Quartos Automaticamente</ModalHeader>
      <ModalBody>
        <form
          onSubmit={(e) => {
            e.preventDefault();
          }}
        >
          <Row>
            <Col md={12}>
              <label className="form-labe label-tooltip">
                Respeitar segregação por grupos/cargo ? *
              </label>
              <div style={{ display: "flex" }}>
                <div className="form-check mb-3" style={{ marginRight: 10 }}>
                  <input
                    className="form-check-input"
                    type="radio"
                    name="segregar"
                    id="segregar2"
                    value="option2"
                    defaultChecked={false}
                    onChange={(e) => setGetByGroup(false)}
                  />
                  <label className="form-check-label" htmlFor="segregar2">
                    Não
                  </label>
                </div>
                <div className="form-check mb-3" style={{ marginRight: 10 }}>
                  <input
                    className="form-check-input"
                    type="radio"
                    name="segregar"
                    id="segregar1"
                    value="option1"
                    defaultChecked={false}
                    onChange={(e) => setGetByGroup(true)}
                  />
                  <label className="form-check-label" htmlFor="segregar1">
                    Sim
                  </label>
                </div>
              </div>
            </Col>
            {/* <div>
              <label className="switch" style={{ display: "flex" }}>
                <input
                  type="checkbox"
                  onChange={(e) => setGetByGroup(e.target.checked)}
                />
                <span className="slider round" style={{ marginLeft: 10 }}>
                  Respeitar segregação por grupos/cargo
                </span>
              </label>
            </div> */}
          </Row>
          <Row>
            <span
              className="slider round"
              style={{ textAlign: "center", marginTop: 20, color: "red" }}
            >
              {errorAlert}
            </span>
          </Row>
          {/* <Row>
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                marginTop: 20,
              }}
            >
              <Button
                color="success"
                className="btn btn-success waves-effect waves-light"
                style={{ width: "250px" }}
                disabled={getByGroup == null}
                onClick={() => {
                  if (getByGroup) getAllMatchNoRoom();
                  else getAllMatchNoRoomNoGroup();
                }}
              >
                Gerar Quartos e Salvar
              </Button>
            </div>
          </Row> */}

          <Row>
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                marginTop: 20,
              }}
            >
              {/* <Button
                color="success"
                className="btn btn-success waves-effect waves-light"
                style={{ width: "250px" }}
                disabled={getByGroup == null}
                onClick={() => {
                  if (getByGroup) getAllMatchNoRoom("download");
                  else getAllMatchNoRoomNoGroup("download");
                }}
              >
                Gerar Quartos e exportar Planilha
              </Button> */}
              <ButtonSpinner
                size={250}
                isLoading={isLoading}
                isDisabled={getByGroup == null}
                title={"Gerar Quartos e exportar Planilha"}
                onClick={
                  getByGroup
                    ? () => getAllMatchNoRoom("download")
                    : () => getAllMatchNoRoomNoGroup("download")
                }
              />
            </div>
          </Row>
        </form>
      </ModalBody>
    </Modal>
  );
}

const mapStateToProps = (state) => {
  return { state };
};

export default connect(mapStateToProps)(ModalLinksEmbeded);
